export const certificationConstants = {
    CREATE_COMMODITY: 'CREATE_COMMODITY',
    CREATE_COMMODITY_FAILURE: 'CREATE_COMMODITY_FAILURE',
};
